import { useMemo } from "react";
import {
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable
} from "@tanstack/react-table";

import {
    dataViewGlobalFilter,
    filtersToColumnFilters,
    toTableColumn
} from "./dataViewTools";

export const useDataViewReactTable = (props)=>{
    const {
        activeView,
        columns=[],
        filters={},
        globalFilter,
        rows=[],
        setGlobalFilter,
        setSorting,
        sorting=[]
    } = props;

    const tableColumns = useMemo(()=>columns.map(column=>toTableColumn(column, activeView)), [activeView, columns]);
    const columnFilters = useMemo(()=>filtersToColumnFilters(filters), [filters]);
    const table = useReactTable({
        data:rows,
        columns:tableColumns,
        state:{ columnFilters, globalFilter, sorting },
        onGlobalFilterChange:setGlobalFilter,
        onSortingChange:setSorting,
        globalFilterFn:dataViewGlobalFilter,
        getCoreRowModel:getCoreRowModel(),
        getFilteredRowModel:getFilteredRowModel(),
        getSortedRowModel:getSortedRowModel()
    });

    return {
        bodyRows:table.getRowModel().rows,
        table
    };
};
